// extracted by mini-css-extract-plugin
module.exports = {"off-grid-B":"B_off-grid-B__uQQ_t","CircleProgress":"B_CircleProgress__Nm_ZC"};